var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAmex = function SvgAmex(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "#1F72CD",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.627 9 4 14.986h3.145l.39-.954h.89l.39.954h3.462v-.728l.308.728h1.79l.309-.744v.744h7.199l.875-.93.82.93 3.697.008-2.635-2.984L27.275 9h-3.64l-.852.913L21.989 9h-7.831l-.673 1.545L12.797 9H9.66v.704L9.31 9zm.608.852h1.533l1.742 4.059v-4.06h1.68l1.345 2.911 1.24-2.91h1.671v4.295H15.43l-.008-3.366-1.482 3.366h-.91l-1.49-3.366v3.366H9.448l-.397-.963H6.91l-.395.962h-1.12zm14.275 0h-4.134v4.293h4.07l1.312-1.423 1.264 1.423h1.322l-1.921-2.134 1.92-2.16H24.08l-1.305 1.407zm-13.53.726-.705 1.716h1.41zm10.417.945v-.784h2.58l1.125 1.253-1.175 1.261h-2.53v-.856h2.255v-.874z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAmex);
export default ForwardRef;